/* Cart drawer: intercepts add-to-cart, previews the cart from the right */
(function () {
  var drawer = document.getElementById("kcDrawer");
  var overlay = document.getElementById("kcDrawerOverlay");
  if (!drawer || !overlay) return;
  var itemsEl = document.getElementById("kcDrawerItems");
  var totalEl = document.getElementById("kcDrawerTotal");
  var shipEl = document.getElementById("kcDrawerShip");
  var FREE_SHIP = 12500;

  function money(cents) { return "$" + (cents / 100).toFixed(2); }
  function img(url) {
    if (!url) return "";
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=160";
  }
  function open() {
    overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
      overlay.classList.add("is-on");
    });
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }
  function close() {
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-on");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    setTimeout(function () { overlay.hidden = true; }, 320);
  }
  overlay.addEventListener("click", close);
  document.getElementById("kcDrawerClose").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  function badge(count) {
    var cartLink = document.querySelector(".icon-btn--cart");
    if (!cartLink) return;
    var b = cartLink.querySelector(".cart-count");
    if (count > 0) {
      if (!b) { b = document.createElement("span"); b.className = "cart-count"; cartLink.appendChild(b); }
      b.textContent = count;
    } else if (b) { b.remove(); }
  }

  function render(cart) {
    badge(cart.item_count);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<li class="kc-drawer__empty">Your cart is empty.</li>';
      shipEl.innerHTML = "";
    } else if (cart.total_price >= FREE_SHIP) {
      shipEl.innerHTML = '<p class="kc-drawer__ship-msg is-free">You&rsquo;ve unlocked free shipping.</p>';
    } else {
      var pct = Math.min(100, Math.round(cart.total_price * 100 / FREE_SHIP));
      shipEl.innerHTML = '<p class="kc-drawer__ship-msg">' + money(FREE_SHIP - cart.total_price) + " away from free shipping</p>" +
        '<div class="kc-drawer__bar"><span style="width:' + pct + '%"></span></div>';
    }
    if (cart.item_count > 0) {
      itemsEl.innerHTML = cart.items.map(function (it, i) {
        var plan = it.selling_plan_allocation ? '<p class="kc-drawer__plan">' + it.selling_plan_allocation.selling_plan.name + " &middot; subscription</p>" : "";
        return '<li class="kc-drawer__item">' +
          '<button type="button" class="kc-drawer__x" data-line="' + (i + 1) + '" data-q="0" aria-label="Remove ' + it.product_title.replace(/"/g, "") + '">&times;</button>' +
          '<a href="' + it.url + '"><img src="' + img(it.image) + '" alt="" loading="lazy" /></a>' +
          '<div class="kc-drawer__mid"><p class="kc-drawer__name"><a href="' + it.url + '">' +
          it.product_title.replace(/KILL CLIFF /g, "") + "</a></p>" +
          (it.variant_title && it.variant_title !== "Default Title" ? '<p class="kc-drawer__var">' + it.variant_title + "</p>" : "") +
          plan +
          '<div class="kc-drawer__qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
          "<span>" + it.quantity + "</span>" +
          '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div></div>' +
          '<span class="kc-drawer__price">' + money(it.final_line_price) + "</span></li>";
      }).join("");
    }
    totalEl.textContent = money(cart.total_price);
  }

  var upsellEl = document.getElementById("kcDrawerUpsell");
  function money2(cents) { return "$" + (cents / 100).toFixed(2); }
  function renderUpsells(cart) {
    if (!upsellEl) return;
    if (cart.item_count === 0) { upsellEl.innerHTML = ""; return; }
    var inCart = cart.items.map(function (i) { return i.product_id; });
    fetch("/recommendations/products.json?product_id=" + cart.items[0].product_id + "&limit=6")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var recs = (d.products || []).filter(function (p) {
          return inCart.indexOf(p.id) === -1 && p.available;
        }).slice(0, 2);
        if (!recs.length) { upsellEl.innerHTML = ""; return; }
        upsellEl.innerHTML = '<p class="kc-drawer__up-title">Complete the loadout</p>' + recs.map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          return '<div class="kc-drawer__up">' +
            '<a href="' + p.url + '"><img src="' + img(p.featured_image || (p.images && p.images[0]) || "") + '" alt="" loading="lazy" /></a>' +
            '<div class="kc-drawer__up-mid"><p>' + p.title.replace(/KILL CLIFF /g, "") + "</p>" +
            '<span>' + money2(v.price) + "</span></div>" +
            '<button type="button" class="kc-drawer__up-add" data-vid="' + v.id + '" aria-label="Add ' + p.title.replace(/"/g, "") + '">+ Add</button></div>';
        }).join("");
      }).catch(function () { upsellEl.innerHTML = ""; });
  }
  if (upsellEl) upsellEl.addEventListener("click", function (e) {
    var b = e.target.closest(".kc-drawer__up-add");
    if (!b) return;
    b.disabled = true; b.textContent = "\u2026";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(b.dataset.vid, 10), quantity: 1 })
    }).then(function () { return refresh(false); });
  });

  function refresh(openAfter) {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      render(c);
      renderUpsells(c);
      if (openAfter) open();
    });
  }

  itemsEl.addEventListener("click", function (e) {
    var b = e.target.closest("button[data-line]");
    if (!b) return;
    b.disabled = true;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: parseInt(b.dataset.q, 10) })
    }).then(function (r) { return r.json(); }).then(function (c) { render(c); renderUpsells(c); });
  });

  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!(f.getAttribute("action") || "").match(/\/cart\/add/)) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]') || document.querySelector('[form="' + f.id + '"][type="submit"]');
    if (btn) btn.disabled = true;
    fetch("/cart/add.js", { method: "POST", body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () { return refresh(true); })
      .catch(function () { f.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  }, true);

  var cartLink = document.querySelector(".icon-btn--cart");
  if (cartLink) cartLink.addEventListener("click", function (e) {
    if (location.pathname === "/cart") return;
    e.preventDefault();
    refresh(true);
  });
})();
